// Single source of truth for ASG warranties.
//
// Every ASG warranty is 3 years, running from the date of delivery. (Our
// printed installation manual refers to the installation date; the website is
// the authoritative version and states delivery.) What it covers depends on
// the product family (owner, 2026-09-30):
//   - awnings: the whole awning, fabric included - never "structural", and
//     no separate fabric term;
//   - pergolas: structural - defects in the frame and fixings.
// On both, the Dooya motor and other electrical components (wind sensor, LED
// lighting) are covered by their manufacturers, separately.
export const WARRANTY_STARTS_FROM = 'date of delivery';
// Every ASG warranty; copy about the range as a whole uses this one.
export const WARRANTY_YEARS = 3;
export const AWNING_WARRANTY_YEARS = WARRANTY_YEARS;
export const PERGOLA_STRUCTURAL_WARRANTY_YEARS = WARRANTY_YEARS;

// The wording for each family. Copy that names or describes a warranty reads
// it from here (or through warrantyFor) rather than spelling it out.
export const WARRANTY_COVER = {
  awning: {
    years: AWNING_WARRANTY_YEARS,
    label: `${AWNING_WARRANTY_YEARS}-year warranty`,
    covers: 'the whole awning, fabric included',
    summary: `The whole awning, fabric included, is covered for ${AWNING_WARRANTY_YEARS} years from the ${WARRANTY_STARTS_FROM}.`,
  },
  pergola: {
    years: PERGOLA_STRUCTURAL_WARRANTY_YEARS,
    label: `${PERGOLA_STRUCTURAL_WARRANTY_YEARS}-year structural warranty`,
    covers: 'structural defects in the frame and fixings',
    summary: `Structural defects in the frame and fixings are covered for ${PERGOLA_STRUCTURAL_WARRANTY_YEARS} years from the ${WARRANTY_STARTS_FROM}.`,
  },
};

// The cover for a product category. Everything that is not an awning is a
// structure and takes the pergola cover; accessories carry their maker's
// warranty instead, which the product page handles on its own.
export const warrantyFor = (category) => WARRANTY_COVER[category === 'awning' ? 'awning' : 'pergola'];

// How long an awning, fabric included, is built to last. NOT a warranty term:
// the warranty above is 3 years on the whole awning, fabric included, and
// copy must never merge the two into a 10-year warranty (owner, 2026-09-30).
// Sauleda's own up-to-10-year fabric cover is deliberately not quoted.
export const EXPECTED_LIFE_YEARS = 10;
